import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Brush = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Brush' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M10.4350288,13.8510725 C8.66912406,14.6226292 7.43502884,16.3847098 7.43502884,18.4350288 C7.43502884,21.1964526 12.4350288,25.4350288 12.4350288,25.4350288 C12.4350288,25.4350288 17.4350288,21.1964526 17.4350288,18.4350288 C17.4350288,16.3847098 16.2009336,14.6226292 14.4350288,13.8510725 L14.4350288,-0.564864977 C14.4350288,-1.67491274 13.5395983,-2.56497116 12.4350288,-2.56497116 C11.3227585,-2.56497116 10.4350288,-1.66949312 10.4350288,-0.564864977 L10.4350288,13.8510725 Z M10,12 L12.6000977,12 L15,12' transform='rotate(45 12.435 11.435)' />
  </StyledIcon>
);
